import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { useTaal } from "../contexts/TaalContext";
import { PERSOONLIJK, WISSEL_BERICHT, kiezerOpties, leesActiefTeam, zetActiefTeam } from "../lib/actiefTeam";

/**
 * K2 (Frank, 18 oktober 2026): de werkruimte kiezen, bovenaan in de zijbalk.
 *
 * Een gewone keuzelijst, zodat de telefoon zijn eigen keuzemenu toont en de Mac
 * het zijne. Persoonlijk is de standaard. Zonder teams staat hier niets: er is
 * dan niets te kiezen, en een lijst met een optie is ruis.
 */
export default function TeamKiezer() {
  const { t } = useTaal();
  const [teams, setTeams] = useState([]);
  const [keuze, setKeuze] = useState(PERSOONLIJK);

  useEffect(() => {
    let blijft = true;
    axios.get(`${API}/teams`).then((r) => blijft && setTeams(r.data || [])).catch(() => {});
    leesActiefTeam().then((k) => blijft && setKeuze(k)).catch(() => {});
    const meelopen = (e) => setKeuze(e.detail ?? PERSOONLIJK);
    window.addEventListener(WISSEL_BERICHT, meelopen);
    return () => { blijft = false; window.removeEventListener(WISSEL_BERICHT, meelopen); };
  }, []);

  if (!teams.length) return null;

  const wissel = async (e) => {
    const vorige = keuze;
    setKeuze(e.target.value);
    try {
      await zetActiefTeam(e.target.value);
    } catch {
      setKeuze(vorige);
      toast.error(t("Werkruimte wisselen mislukt"));
    }
  };

  return (
    <label className="block px-3 pb-2">
      <span className="sr-only">{t("Werkruimte")}</span>
      <select value={keuze} onChange={wissel} data-testid="team-kiezer"
              className="tap-target w-full h-8 rounded-md border border-input bg-background px-2 text-sm">
        {kiezerOpties(teams, t).map((o) => (
          <option key={o.id || "persoonlijk"} value={o.id}>{o.naam}</option>
        ))}
      </select>
    </label>
  );
}
